class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    const closeBtn = this.querySelector('button[type="button"]');

    if (this.detailsContainer) {
      this.detailsContainer.addEventListener(
        "keyup",
        event => event.code.toUpperCase() === "ESCAPE" && this.close()
      );
    }
    if (this.summaryToggle) {
      this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
      this.summaryToggle.setAttribute("role", "button");
    }
    if (closeBtn) {
      closeBtn.addEventListener("click", this.close.bind(this));
    }
  }

  isOpen() {
    return this.detailsContainer ? this.detailsContainer.hasAttribute("open") : false;
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target ? event.target.closest("details") : this.detailsContainer;
    if (details) {
      details.hasAttribute("open") ? this.close() : this.open(event);
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains("modal-overlay"))
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const details = event && event.target ? event.target.closest("details") : this.detailsContainer;
    if (details) details.setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    if (this.detailsContainer) {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    if (this.detailsContainer) this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("details-modal", DetailsModal);
